import { supabase } from "@/lib/supabase";

export async function getRequestAuthHeaders(): Promise<Record<string, string>> {
  // On localhost, create a mock auth header for mock user
  const isLocalhost = typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
  if (isLocalhost) {
    // Use a placeholder token - localhost endpoints will bypass auth checks
    return { Authorization: `Bearer localhost-mock-token` };
  }

  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;

  if (!token) {
    return {};
  }

  return { Authorization: `Bearer ${token}` };
}